import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

class MaxWidthLayout extends PureComponent {
  render() {
    const baseStyles = 'w-100';
    const spacingStyles = `${this.props.hasMobileGutter ? 'ph3' : 'overflow-hidden'} ph3-m ph4-l`;
    const innerStyles = 'mw9 center';

    return (
      <div className={`max-width-layout ${baseStyles} ${spacingStyles}`}>
        <div className={`${innerStyles}`}>{this.props.children}</div>
      </div>
    );
  }
}

MaxWidthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hasMobileGutter: PropTypes.bool,
};

MaxWidthLayout.defaultProps = {
  hasMobileGutter: true,
};

export default MaxWidthLayout;
